const roundToDecimalPlaces = (amount: number, decimalPlaces: number): number => {
  const factor = 10 ** decimalPlaces;
  const scaledAmount = amount * factor;
  const roundedAmount =
    scaledAmount < 0 ? -Math.round(Math.abs(scaledAmount)) : Math.round(scaledAmount);

  return roundedAmount / factor;
};

export const roundUnitPrice = (amount: number): number => roundToDecimalPlaces(amount, 5);

export const roundPayableAmount = (amount: number): number => roundToDecimalPlaces(amount, 2);
